import React from "react";
import PropTypes from "prop-types";
const ShapesIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
        d="M5.997 11.944L1.766 19h8.467l-4.236-7.056z"
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="3.5"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
      />
      <rect
        width="7"
        height="7"
        x="12"
        y="7"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        rx="1"
      />
    </g>
  </svg>
);
ShapesIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ShapesIcon;
